<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content">
            <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-500px"></i> fab fa-500px 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-accessible-icon"></i> fab fa-accessible-icon
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-accusoft"></i> fab fa-accusoft 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-acquisitions-incorporated"></i> fab fa-acquisitions-incorporated
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ad"></i> fas fa-ad
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-address-book"></i> fas fa-address-book 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-address-book"></i> far fa-address-book 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-address-card"></i> fas fa-address-card 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-address-card"></i> far fa-address-card 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-adjust"></i> fas fa-adjust 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-adn"></i> fab fa-adn 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-adobe"></i> fab fa-adobe 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-adversal"></i> fab fa-adversal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-affiliatetheme"></i> fab fa-affiliatetheme 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-air-freshener"></i> fas fa-air-freshener 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-algolia"></i> fab fa-algolia 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-align-center"></i> fas fa-align-center 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-align-justify"></i> fas fa-align-justify 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-align-left"></i> fas fa-align-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-align-right"></i> fas fa-align-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-alipay"></i> fab fa-alipay 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-allergies"></i> fas fa-allergies 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-amazon"></i> fab fa-amazon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-amazon-pay"></i> fab fa-amazon-pay 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ambulance"></i> fas fa-ambulance 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-american-sign-language-interpreting"></i> fas fa-american-sign-language-interpreting 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-amilia"></i> fab fa-amilia 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-anchor"></i> fas fa-anchor 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-android"></i> fab fa-android 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-angellist"></i> fab fa-angellist 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angle-double-down"></i> fas fa-angle-double-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angle-double-left"></i> fas fa-angle-double-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angle-double-right"></i> fas fa-angle-double-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angle-double-up"></i> fas fa-angle-double-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angle-down"></i> fas fa-angle-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angle-left"></i> fas fa-angle-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angle-right"></i> fas fa-angle-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angle-up"></i> fas fa-angle-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angry"></i> fas fa-angry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-angry"></i> fas fa-angry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-angrycreative"></i> fab fa-angrycreative 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-angular"></i> fab fa-angular 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ankh"></i> fas fa-ankh 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-app-store"></i> fab fa-app-store 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-app-store-ios"></i> fab fa-app-store-ios 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-apper"></i> fab fa-apper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-apple"></i> fab fa-apple 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-apple-alt"></i> fas fa-apple-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-apple-pay"></i> fab fa-apple-pay 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-archive"></i> fas fa-archive 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-archway"></i> fas fa-archway 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-alt-circle-down"></i> fas fa-arrow-alt-circle-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-arrow-alt-circle-down"></i> far fa-arrow-alt-circle-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-alt-circle-left"></i> fas fa-arrow-alt-circle-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-arrow-alt-circle-left"></i>far fa-arrow-alt-circle-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-alt-circle-right"></i> fas fa-arrow-alt-circle-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-arrow-alt-circle-right"></i>far fa-arrow-alt-circle-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-alt-circle-up"></i> fas fa-arrow-alt-circle-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-arrow-alt-circle-up"></i>far fa-arrow-alt-circle-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-circle-down"></i> fas fa-arrow-circle-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-circle-left"></i>fas fa-arrow-circle-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-circle-right"></i> fas fa-arrow-circle-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-circle-up"></i> fas fa-arrow-circle-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-down"></i> fas fa-arrow-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-left"></i> fas fa-arrow-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-right"></i> fas fa-arrow-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrow-up"></i> fas fa-arrow-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrows-alt"></i> fas fa-arrows-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrows-alt-h"></i> fas fa-arrows-alt-h 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-arrows-alt-v"></i> fas fa-arrows-alt-v 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-artstation"></i> fab fa-artstation 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-assistive-listening-systems"></i> fas fa- 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-asterisk"></i> fas fa-asterisk 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-asymmetrik"></i> fab fa-asymmetrik 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-at"></i> fas fa-at 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-atlas"></i> fas fa-atlas 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-atlassian"></i> fab fa-atlassian 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-atom"></i> fas fa-atom 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-audible"></i> fab fa-audible 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-audio-description"></i> fas fa-audio-description 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-autoprefixer"></i> fab fa-autoprefixer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-avianex"></i> fab fa-avianex 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-aviato"></i> fab fa-aviato 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-award"></i> fas fa-award 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-aws"></i> fab fa-aws 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-baby"></i> fas fa-baby 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-baby-carriage"></i> fas fa-baby-carriage 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-backspace"></i> fas fa-backspace 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-backward"></i> fas fa-backward 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bacon"></i> fas fa-bacon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-balance-scale"></i> fas fa-balance-scale 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ban"></i> fas fa-ban 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-band-aid"></i> fas fa-band-aid 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-bandcamp"></i> fab fa-bandcamp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-barcode"></i> fas fa-barcode 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bars"></i> fas fa-bars 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-baseball-ball"></i> fas fa-baseball-ball 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-basketball-ball"></i> fas fa-basketball-ball 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bath"></i> fas fa-bath 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-battery-empty"></i> fas fa-battery-empty 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-battery-full"></i> fas fa-battery-full 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-battery-half"></i> fas fa-battery-half 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-battery-quarter"></i> fas fa-battery-quarter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-battery-three-quarters"></i> fas fa-battery-three-quarters 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bed"></i> fas fa-bed 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-beer"></i> fas fa-beer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-behance"></i> fab fa-behance 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-behance-square"></i> fab fa-behance-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bell"></i> fas fa-bell 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bell"></i> fas fa-bell 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bell-slash"></i> fas fa-bell-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bell-slash"></i> fas fa-bell-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bezier-curve"></i> fas fa-bezier-curve 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bible"></i> fas fa- 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bicycle"></i> fas fa-bicycle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-binoculars"></i> fas fa-binoculars 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-biohazard"></i> fas fa-biohazard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-birthday-cake"></i> fas fa-birthday-cake 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-bitbucket"></i> fab fa-bitbucket 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-bitcoin"></i> fab fa-bitcoin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-bity"></i> fab fa-bity 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-black-tie"></i> fab fa-black-tie 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-blackberry"></i> fab fa-blackberry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-blender"></i> fas fa-blender 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-blender-phone"></i> fas fa-blender-phone 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-blind"></i> fas fa-blind 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-blog"></i> fas fa-blog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-blogger"></i> fab fa-blogger 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-blogger-b"></i> fab fa-blogger-b 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-bluetooth"></i> fab fa-bluetooth 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-bluetooth-b"></i> fab fa-bluetooth-b 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bold"></i> fas fa-bold 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bolt"></i> fas fa-bolt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bomb"></i> fas fa-bomb 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bone"></i> fas fa-bone 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bong"></i> fas fa-bong 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-book"></i> fas fa-book 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-book-dead"></i> fas fa-book-dead 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-book-medical"></i> fas fa-book-medical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-book-open"></i> fas fa-book-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-book-reader"></i> fas fa-book-reader 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bookmark"></i> fas fa-bookmark 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-bookmark"></i> far fa-bookmark 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bowling-ball"></i> fas fa-bowling-ball 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-box"></i> fas fa-box 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-box-open"></i> fas fa-box-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-boxes"></i> fas fa-boxes 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-braille"></i> fas fa-braille 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-brain"></i> fas fa-brain 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bread-slice"></i> fas fa-bread-slice 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-briefcase"></i> fas fa-briefcase 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-briefcase-medical"></i> fas fa-briefcase-medical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-broadcast-tower"></i> fas fa-broadcast-tower 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-broom"></i> fas fa-broom 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-brush"></i> fas fa-brush 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-btc"></i> fab fa-btc 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bug"></i> fas fa-bug 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-building"></i> fas fa-building 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-building"></i> fas fa-building 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bullhorn"></i> fas fa-bullhorn 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bullseye"></i> fas fa-bullseye 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-burn"></i> fas fa-burn
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-buromobelexperte"></i> fab fa-buromobelexperte 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bus"></i> fas fa-bus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-bus-alt"></i> fas fa-bus-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-business-time"></i> fas fa-business-time 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-buysellads"></i> fab fa-buysellads 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calculator"></i> fas fa-calculator 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calendar"></i> fas fa-calendar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-calendar"></i> far fa-calendar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calendar-alt"></i> fas fa-calendar-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-calendar-alt"></i> far fa-calendar-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calendar-check"></i> fas fa-calendar-check 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-calendar-check"></i> far fa-calendar-check 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calendar-day"></i> fas fa-calendar-day 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calendar-minus"></i> fas fa-calendar-minus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-calendar-minus"></i> far fa-calendar-minus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calendar-plus"></i> fas fa-calendar-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-calendar-plus"></i> far fa-calendar-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calendar-times"></i> fas fa-calendar-times 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-calendar-times"></i> far fa-calendar-times 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-calendar-week"></i> fas fa-calendar-week 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-camera"></i> fas fa-camera 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-camera-retro"></i> fas fa-camera-retro 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-campground"></i> fas fa-campground 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-canadian-maple-leaf"></i> fab fa-canadian-maple-leaf 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-candy-cane"></i> fas fa-candy-cane 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cannabis"></i> fas fa-cannabis 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-capsules"></i> fas fa-capsules 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-car"></i> fas fa-car 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-car-alt"></i> fas fa-car-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-car-battery"></i> fas fa-car-battery 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-car-crash"></i> fas fa-car-crash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-car-side"></i> fas fa-car-side 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-caret-down"></i> fas fa-caret-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-caret-left"></i> fas fa-caret-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-caret-right"></i> fas fa-caret-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-caret-square-down"></i> fas fa-caret-square-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-caret-square-down"></i> far fa-caret-square-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-caret-square-left"></i> fas fa-caret-square-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-caret-square-left"></i> far fa-caret-square-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-caret-square-right"></i> fas fa-caret-square-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-caret-square-right"></i> far fa-caret-square-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-caret-square-up"></i> fas fa-caret-square-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-caret-square-up"></i> far fa-caret-square-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-caret-up"></i> fas fa-caret-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-carrot"></i> fas fa-carrot 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cart-arrow-down"></i> fas fa-cart-arrow-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cart-plus"></i> fas fa-cart-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cash-register"></i> fas fa-cash-register 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cat"></i> fas fa-cat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-amazon-pay"></i> fab fa-cc-amazon-pay 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-amex"></i> fab fa-cc-amex 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-apple-pay"></i> fab fa-cc-apple-pay 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-diners-club"></i> fab fa-diners-club 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-discover"></i> fab fa-cc-discover 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-jcb"></i> fab fa-cc-jcb 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-mastercard"></i> fab fa-cc-mastercard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-paypal"></i> fab fa-cc-paypal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-stripe"></i> fab fa-cc-stripe 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cc-visa"></i> fab fa-cc-visa 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-centercode"></i> fab fa-centercode 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-centos"></i> fab fa-centos 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-certificate"></i> fas fa-certificate 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chair"></i> fas fa-chair 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chalkboard"></i> fas fa-chalkboard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chalkboard-teacher"></i> fas fa-chalkboard-teacher 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-charging-station"></i> fas fa-charging-station 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chart-area"></i> fas fa-chart-area 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chart-bar"></i> fas fa-chart-bar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chart-bar"></i> fas fa-chart-bar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chart-line"></i> fas fa-chart-line 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chart-pie"></i> fas fa-chart-pie 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-check"></i> fas fa-check 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-check-circle"></i> fas fa-check-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-check-circle"></i> fas fa-check-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-check-double"></i> fas fa-check-double 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-check-square"></i> fas fa-check-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-check-square"></i> fas fa-check-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cheese"></i> fas fa-cheese 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chess"></i> fas fa-chess 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chess-bishop"></i> fas fa-chess-bishop 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chess-board"></i> fas fa-chess-board 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chess-king"></i> fas fa-chess-king 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chess-knight"></i> fas fa-chess-knight 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chess-pawn"></i> fas fa-chess-pawn 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chess-queen"></i> fas fa-chess-queen 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chess-rook"></i> fas fa-chess-rook 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chevron-circle-down"></i> fas fa-chevron-circle-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chevron-circle-left"></i> fas fa-chevron-circle-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chevron-circle-right"></i> fas fa-chevron-circle-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chevron-circle-up"></i> fas fa-chevron-circle-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chevron-down"></i> fas fa-chevron-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chevron-left"></i> fas fa-chevron-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chevron-right"></i> fas fa-chevron-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-chevron-up"></i> fas fa-chevron-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-child"></i> fas fa-child 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-chrome"></i> fab fa-chrome 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-church"></i> fas fa-church 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-circle"></i> fas fa-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-circle"></i> far fa-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-circle-notch"></i> fas fa-circle-notch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-city"></i> fas fa-city 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-clinic-medical"></i> fas fa-clinic-medical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-clipboard"></i> fas fa-clipboard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-clipboard"></i> fas fa-clipboard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-clipboard-check"></i> fas fa-clipboard-check 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-clipboard-list"></i> fas fa-clipboard-list 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-clock"></i> fas fa-clock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-clock"></i> far fa-clock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-clone"></i> fas fa-clone 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-clone"></i> far fa-clone 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-closed-captioning"></i> fas fa-closed-captioning 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-closed-captioning"></i> far fa-closed-captioning 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud"></i> fas fa-cloud 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-download-alt"></i> fas fa-cloud-download-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-meatball"></i> fas fa-cloud-meatball 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-moon"></i> fas fa-cloud-moon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-moon-rain"></i> fas fa-cloud-moon-rain 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-rain"></i> fas fa-cloud-rain 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-showers-heavy"></i> fas fa-cloud-showers-heavy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-sun"></i> fas fa-cloud-sun 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-sun-rain"></i> fas fa-cloud-sun-rain 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cloud-upload-alt"></i> fas fa-cloud-upload-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cloudscale"></i> fab fa-cloudscale 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cloudsmith"></i> fab fa-cloudsmith 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cloudversify"></i> fab fa-cloudversify 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cocktail"></i> fas fa-cocktail 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-code"></i> fas fa-code 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-code-branch"></i> fas fa-code-branch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-codepen"></i> fab fa-codepen 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-codiepie"></i> fab fa-codiepie 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-coffee"></i> fas fa-coffee 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cog"></i> fas fa-cog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cogs"></i> fas fa-cogs 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-coins"></i> fas fa-coins 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-columns"></i> fas fa-columns 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-comment"></i> fas fa-comment 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-comment"></i> far fa-comment 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-comment-alt"></i> fas fa-comment-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-comment-alt"></i> far fa-comment-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-comment-dollar"></i> fas fa-comment-dollar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-comment-dots"></i> fas fa-comment-dots 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-comment-dots"></i> far fa-comment-dots 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-comment-medical"></i> fas fa-comment-medical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-comment-slash"></i> fas fa-comment-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-comments"></i> fas fa-comments 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-comments"></i> far fa-comments 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-comments-dollar"></i> fas fa-comments-dollar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-compact-disc"></i> fas fa-compact-disc 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-compass"></i> fas fa-compass 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-compass"></i> far fa-compass 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-compress"></i> fas fa-compress 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-compress-arrows-alt"></i> fas fa-compress-arrows-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-concierge-bell"></i> fas fa-concierge-bell 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-confluence"></i> fab fa-confluence 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-connectdevelop"></i> fab fa-connectdevelop 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-contao"></i> fab fa-contao 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cookie"></i> fas fa-cookie 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cookie-bite"></i> fas fa-cookie-bite 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-copy"></i> fas fa-copy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-copy"></i> far fa-copy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-copyright"></i> fas fa-copyright 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-copyright"></i> far fa-copyright 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-couch"></i> fas fa-couch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cpanel"></i> fab fa-cpanel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons"></i> fab fa-creative-commons 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-by"></i> fab fa-creative-commons-by 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-nc"></i> fab fa-creative-commons-nc 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-nc-eu"></i> fab fa-creative-commons-nc-eu 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-nc-jp"></i> fab fa-creative-commons-nc-jp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-nd"></i> fab fa-creative-commons-nd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-pd"></i> fab fa-creative-commons-pd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-pd-alt"></i> fab fa-creative-commons-pd-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-remix"></i> fab fa-creative-commons-remix 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-sa"></i> fab fa-creative-commons-sa 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-sampling"></i> fab fa-creative-commons-sampling 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-sampling-plus"></i> fab fa-creative-commons-sampling-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-share"></i> fab fa-creative-commons-share 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-creative-commons-zero"></i> fab fa-creative-commons-zero 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-credit-card"></i> fas fa-credit-card 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-credit-card"></i> far fa-credit-card 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-critical-role"></i> fab fa-critical-role 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-crop"></i> fas fa-crop 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-crop-alt"></i> fas fa-crop-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cross"></i> fas fa-cross 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-crosshairs"></i> fas fa-crosshairs 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-crow"></i> fas fa-crow 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-crown"></i> fas fa-crown 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-crutch"></i> fas fa-crutch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-css3"></i> fab fa-css3 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-css3-alt"></i> fab fa-css3-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cube"></i> fas fa-cube 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cubes"></i> fas fa-cubes 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-cut"></i> fas fa-cut 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-cuttlefish"></i> fab fa-cuttlefish 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-d-and-d"></i> fab fa-d-and-d 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-d-and-d-beyond"></i> fab fa-d-and-d-beyond 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-dashcube"></i> fab fa-dashcube 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-database"></i> fas fa-database 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-deaf"></i> fas fa-deaf 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-delicious"></i> fab fa-delicious 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-democrat"></i> fas fa-democrat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-deploydog"></i> fab fa-deploydog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-deskpro"></i> fab fa-deskpro 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-desktop"></i> fas fa-desktop 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-dev"></i> fab fa-dev 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-deviantart"></i> fab fa-deviantart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dharmachakra"></i> fas fa-dharmachakra 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-dhl"></i> fab fa-dhl 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-diagnoses"></i> fas fa-diagnoses 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-diaspora"></i> fab fa-diaspora 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice"></i> fas fa-dice 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice-d20"></i> fas fa-dice-d20 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice-d6"></i> fas fa-dice-d6 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice-five"></i> fas fa-dice-five 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice-four"></i> fas fa-dice-four 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice-one"></i> fas fa-dice-one 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice-six"></i> fas fa-dice-six 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice-three"></i> fas fa-dice-three 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dice-two"></i> fas fa-dice-two 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-digg"></i> fab fa-digg 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-digital-ocean"></i> fab fa-digital-ocean 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-digital-tachograph"></i> fas fa-digital-tachograph 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-directions"></i> fas fa-directions 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-discord"></i> fab fa-discord 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-discourse"></i> fab fa-discourse 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-divide"></i> fas fa-divide 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dizzy"></i> fas fa-dizzy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dizzy"></i> fas fa-dizzy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dna"></i> fas fa-dna 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-dochub"></i> fab fa-dochub 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-docker"></i> fab fa-docker 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dog"></i> fas fa-dog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dollar-sign"></i> fas fa-dollar-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dolly"></i> fas fa-dolly 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dolly-flatbed"></i> fas fa-dolly-flatbed 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-donate"></i> fas fa-donate 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-door-closed"></i> fas fa-door-closed 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-door-open"></i> fas fa-door-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dot-circle"></i> fas fa-dot-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dot-circle"></i> fas fa-dot-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dove"></i> fas fa-dove 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-download"></i> fas fa-download 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-draft2digital"></i> fab fa-draft2digital 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-drafting-compass"></i> fas fa-drafting-compass 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dragon"></i> fas fa-dragon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-draw-polygon"></i> fas fa-draw-polygon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-dribbble"></i> fab fa-dribbble 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-dribbble-square"></i> fab fa-dribbble-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-dropbox"></i> fab fa-dropbox 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-drum"></i> fas fa-drum 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-drum-steelpan"></i> fas fa-drum-steelpan 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-drumstick-bite"></i> fas fa-drumstick-bite 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-drupal"></i> fab fa-drupal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dumbbell"></i> fas fa-dumbbell 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dumpster"></i> fas fa-dumpster 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dumpster-fire"></i> fas fa-dumpster-fire 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-dungeon"></i> fas fa-dungeon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-dyalog"></i> fab fa-dyalog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-earlybirds"></i> fab fa-earlybirds 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ebay"></i> fab fa-ebay 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-edge"></i> fab fa-edge 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-edit"></i> fas fa-edit 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-edit"></i> far fa-edit 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-egg"></i> fas fa-egg 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-eject"></i> fas fa-eject 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-elementor"></i> fab fa-elementor 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ellipsis-h"></i> fas fa-ellipsis-h 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ellipsis-v"></i> fas fa-ellipsis-v 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ello"></i> fab fa-ello 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ember"></i> fab fa-ember 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-empire"></i> fab fa-empire 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-envelope"></i> fas fa-envelope 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-envelope"></i> fas fa-envelope 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-envelope-open"></i> fas fa-envelope-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-envelope-open"></i> fas fa-envelope-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-envelope-open-text"></i> fas fa-envelope-open-text 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-envelope-square"></i> fas fa-envelope-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-envira"></i> fab fa-envira 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-equals"></i> fas fa-equals 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-eraser"></i> fas fa-eraser 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-erlang"></i> fab fa-erlang 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ethereum"></i> fab fa-ethereum 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ethernet"></i> fas fa-ethernet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-etsy"></i> fab fa-etsy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-euro-sign"></i> fas fa-euro-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-exchange-alt"></i> fas fa-exchange-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-exclamation"></i> fas fa-exclamation 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-exclamation-circle"></i> fas fa-exclamation-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-exclamation-triangle"></i> fas fa-exclamation-triangle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-expand"></i> fas fa-expand 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-expand-arrows-alt"></i> fas fa-expand-arrows-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-expeditedssl"></i> fab fa-expeditedssl 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-external-link-alt"></i> fas fa-external-link-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-external-link-square-alt"></i> fas fa-external-link-square-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-eye"></i> fas fa-eye 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-eye"></i> far fa-eye 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-eye-dropper"></i> fas fa-eye-dropper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-eye-slash"></i> fas fa-eye-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-eye-slash"></i> far fa-eye-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-facebook"></i> fab fa-facebook 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-facebook-f"></i> fab fa-facebook-f 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-facebook-messenger"></i> fab fa-facebook-messenger 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-facebook-square"></i> fab fa-facebook-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fantasy-flight-games"></i> fab fa-fantasy-flight-games 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fast-backward"></i> fas fa-fast-backward 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fast-forward"></i> fas fa-fast-forward 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fax"></i> fas fa-fax 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-feather"></i> fas fa-feather 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-feather-alt"></i> fas fa-feather-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fedex"></i> fab fa-fedex 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fedora"></i> fab fa-fedora 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-female"></i> fas fa-female 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fighter-jet"></i> fas fa-fighter-jet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-figma"></i> fab fa-figma 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file"></i> fas fa-file 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file"></i> far fa-file 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-alt"></i> fas fa-file-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-alt"></i> far fa-file-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-archive"></i> fas fa-file-archive 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-archive"></i> far fa-file-archive 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-audio"></i> fas fa-file-audio 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-audio"></i> far fa-file-audio 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-code"></i> fas fa-file-code 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-code"></i> far fa-file-code 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-contract"></i> fas fa-file-contract 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-csv"></i> fas fa-file-csv 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-download"></i> fas fa-file-download 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-excel"></i> fas fa-file-excel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-excel"></i> far fa-file-excel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-export"></i> fas fa-file-export 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-image"></i> fas fa-file-image 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-image"></i> far fa-file-image 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-import"></i> fas fa-file-import 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-invoice"></i> fas fa-file-invoice 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-invoice-dollar"></i> fas fa-file-invoice-dollar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-medical"></i> fas fa-file-medical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-medical-alt"></i> fas fa-file-medical-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-pdf"></i> fas fa-file-pdf 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-pdf"></i> far fa-file-pdf 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-powerpoint"></i> fas fa-file-powerpoint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-powerpoint"></i> far fa-file-powerpoint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-prescription"></i> fas fa-file-prescription 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-signature"></i> fas fa-file-signature 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-upload"></i> fas fa-file-upload 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-video"></i> fas fa-file-video 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-video"></i> fas fa-file-video 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-file-word"></i> fas fa-file-word 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-file-word"></i> far fa-file-word 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fill"></i> fas fa-fill 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fill-drip"></i> fas fa-fill-drip 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-film"></i> fas fa-film 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-filter"></i> fas fa-filter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fingerprint"></i> fas fa-fingerprint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fire"></i> fas fa-fire 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fire-alt"></i> fas fa-fire-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fire-extinguisher"></i> fas fa-fire-extinguisher 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-firefox"></i> fab fa-firefox 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-first-aid"></i> fas fa-first-aid 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-first-order"></i> fab fa-first-order 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-first-order-alt"></i> fab fa-first-order-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-firstdraft"></i> fab fa-firstdraft 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fish"></i> fas fa-fish 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-fist-raised"></i> fas fa-fist-raised 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-flag"></i> fas fa-flag 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-flag"></i> far fa-flag 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-flag-checkered"></i> fas fa-flag-checkered 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-flag-usa"></i> fas fa-flag-usa 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-flask"></i> fas fa-flask 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-flickr"></i> fab fa-flickr 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-flipboard"></i> fab fa-flipboard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-flushed"></i> fas fa-flushed 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-flushed"></i> far fa-flushed 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fly"></i> fab fa-fly 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-folder"></i> fas fa-folder 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-folder"></i> far fa-folder 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-folder-minus"></i> fas fa-folder-minus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-folder-open"></i> fas fa-folder-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-folder-open"></i> far fa-folder-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-folder-plus"></i> fas fa-folder-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-font"></i> fas fa-font 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-font-awesome"></i> fab fa-font-awesome 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-font-awesome-alt"></i> fab fa-font-awesome-alt
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-font-awesome-flag"></i> fab fa-font-awesome-flag 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fonticons"></i> fab fa-fonticons 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fonticons-fi"></i> fab fa-fonticons-fi 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-football-ball"></i> fas fa-football-ball 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fort-awesome"></i> fab fa-fort-awesome 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fort-awesome-alt"></i> fab fa-fort-awesome-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-forumbee"></i> fab fa-forumbee 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-forward"></i> fas fa-forward 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-foursquare"></i> fab fa-foursquare 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-free-code-camp"></i> fab fa-free-code-camp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-freebsd"></i> fab fa-freebsd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-frog"></i> fas fa-frog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-frown"></i> fas fa-frown 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-frown"></i> far fa-frown 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-frown-open"></i> fas fa-frown-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-frown-open"></i> fas fa-frown-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-frown-open"></i> far fa-frown-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-fulcrum"></i> fab fa-fulcrum 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-funnel-dollar"></i> fas fa-funnel-dollar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-futbol"></i> fas fa-futbol 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-futbol"></i> far fa-futbol 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-galactic-republic"></i> fab fa-galactic-republic 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-galactic-senate"></i> fab fa-galactic-senate 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-gamepad"></i> fas fa-gamepad 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-gas-pump"></i> fas fa-gas-pump 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-gavel"></i> fas fa-gavel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-gem"></i> fas fa-gem 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-gem"></i> far fa-gem 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-genderless"></i> fas fa-genderless 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-get-pocket"></i> fab fa-get-pocket 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gg"></i> fab fa-gg 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gg-circle"></i> fab fa-gg-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ghost"></i> fas fa-ghost 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-gift"></i> fas fa-gift 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-gifts"></i> fas fa-gifts 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-git"></i> fab fa-git 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-git-square"></i> fab fa-git-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-github"></i> fab fa-github 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-github-alt"></i> fab fa-github-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-github-square"></i> fab fa-github-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gitkraken"></i> fab fa-gitkraken 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gitlab"></i> fab fa-gitlab 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gitter"></i> fab fa-gitter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-glass-cheers"></i> fas fa-glass-cheers 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-glass-martini"></i> fas fa-glass-martini 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-glass-martini-alt"></i> fas fa-glass-martini-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-glass-whiskey"></i> fas fa-glass-whiskey 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-glasses"></i> fas fa-glasses 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-glide"></i> fab fa-glide 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-glide-g"></i> fab fa-glide-g 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-globe"></i> fas fa-globe 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-globe-africa"></i> fas fa-globe-africa 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-globe-americas"></i> fas fa-globe-americas 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-globe-asia"></i> fas fa-globe-asia 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-globe-europe"></i> fas fa-globe-europe 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gofore"></i> fab fa-gofore 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-golf-ball"></i> fas fa-golf-ball  
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-goodreads"></i> fab fa-goodreads 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-goodreads-g"></i> fab fa-goodreads-g 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-google"></i> fab fa-google 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-google-drive"></i> fab fa-google-drive 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-google-play"></i> fab fa-google-play 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-google-plus"></i> fab fa-google-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-google-plus-g"></i> fab fa-google-plus-g 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-google-plus-square"></i> fab fa-google-plus-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-google-wallet"></i> fab fa-google-wallet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-gopuram"></i> fas fa-gopuram 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-graduation-cap"></i> fas fa-graduation-cap 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gratipay"></i> fab fa-gratipay 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-grav"></i> fab fa-grav 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-greater-than"></i> fas fa-greater-than 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-greater-than-equal"></i> fas fa-greater-than-equal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grimace"></i> fas fa-grimace 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grimace"></i> far fa-grimace 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin"></i> fas fa-grin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin"></i> far fa-grin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-alt"></i> fas fa-grin-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-alt"></i> far fa-grin-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-beam"></i> fas fa-grin-beam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-beam"></i> far fa-grin-beam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-beam-sweat"></i> fas fa-grin-beam-sweat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-beam-sweat"></i> far fa-grin-beam-sweat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-hearts"></i> fas fa-grin-hearts 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-hearts"></i> far fa-grin-hearts 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-squint"></i> fas fa-grin-squint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-squint"></i> far fa-grin-squint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-squint-tears"></i> fas fa-grin-squint-tears 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-squint-tears"></i> far fa-grin-squint-tears 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-stars"></i> fas fa-grin-stars 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-stars"></i> far fa-grin-stars 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-tears"></i> fas fa-grin-tears 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-tears"></i> far fa-grin-tears 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-tongue"></i> fas fa-grin-tongue 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-tongue"></i> far fa-grin-tongue 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-tongue-squint"></i> fas fa-grin-tongue-squint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-tongue-squint"></i> far fa-grin-tongue-squint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-tongue-wink"></i> fas fa-grin-tongue-wink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-tongue-wink"></i> far fa-grin-tongue-wink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grin-wink"></i> fas fa-grin-wink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-grin-wink"></i> far fa-grin-wink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grip-horizontal"></i> fas fa-grip-horizontal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grip-lines"></i> fas fa-grip-lines 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grip-lines-vertical"></i> fas fa-grip-lines-vertical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-grip-vertical"></i> fas fa-grip-vertical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gripfire"></i> fab fa-gripfire
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-grunt"></i> fab fa-grunt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-guitar"></i> fas fa-guitar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-gulp"></i> fab fa-gulp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-h-square"></i> fas fa-h-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hacker-news"></i> fab fa-hacker-news 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hacker-news-square"></i> fab fa-hacker-news-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hackerrank"></i> fab fa-hackerrank 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hamburger"></i> fas fa-hamburger 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hammer"></i> fas fa-hammer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hamsa"></i> fas fa-hamsa 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-holding"></i> fas fa-hand-holding 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-holding-heart"></i> fas fa-hand-holding-heart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-holding-usd"></i> fas fa-hand-holding-usd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-lizard"></i> fas fa-hand-lizard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-lizard"></i> far fa-hand-lizard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-middle-finger"></i> fas fa-hand-middle-finger 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-paper"></i> fas fa-hand-paper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-paper"></i> far fa-hand-paper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-peace"></i> fas fa-hand-peace 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-peace"></i> far fa-hand-peace 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-point-down"></i> fas fa-hand-point-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-point-down"></i> far fa-hand-point-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-point-left"></i> fas fa-hand-point-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-point-left"></i> far fa-hand-point-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-point-right"></i> fas fa-hand-point-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-point-right"></i> far fa-hand-point-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-point-up"></i> fas fa-hand-point-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-point-up"></i> far fa-hand-point-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-pointer"></i> fas fa-hand-pointer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-pointer"></i> far fa-hand-pointer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-rock"></i> fas fa-hand-rock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-rock"></i> far fa-hand-rock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-scissors"></i> fas fa-hand-scissors 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-scissors"></i> far fa-hand-scissors 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hand-spock"></i> fas fa-hand-spock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hand-spock"></i> far fa-hand-spock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hands"></i> fas fa-hands 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hands-helping"></i> fas fa-hands-helping 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-handshake"></i> fas fa-handshake 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-handshake"></i> far fa-handshake 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hanukiah"></i> fas fa-hanukiah 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hard-hat"></i> fas fa-hard-hat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hashtag"></i> fas fa-hashtag 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hat-wizard"></i> fas fa-hat-wizard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-haykal"></i> fas fa-haykal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hdd"></i> fas fa-hdd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hdd"></i> far fa-hdd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-heading"></i> fas fa-heading 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-headphones"></i> fas fa-headphones 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-headphones-alt"></i> fas fa-headphones-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-headset"></i> fas fa-headset 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-heart"></i> fas fa-heart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-heart"></i> far fa-heart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-heart-broken"></i> fas fa-heart-broken 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-heartbeat"></i> fas fa-heartbeat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-helicopter"></i> fas fa-helicopter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-highlighter"></i> fas fa-highlighter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hiking"></i> fas fa-hiking 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hippo"></i> fas fa-hippo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hips"></i> fab fa-hips 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hire-a-helper"></i> fab fa-hire-a-helper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-history"></i> fas fa-history 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hockey-puck"></i> fas fa-hockey-puck 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-holly-berry"></i> fas fa-holly-berry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-home"></i> fas fa-home 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hooli"></i> fab fa-hooli 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hornbill"></i> fab fa-hornbill 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-horse"></i> fas fa-horse 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-horse-head"></i> fas fa-horse-head 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hospital"></i> fas fa-hospital 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-hospital"></i> far fa-hospital 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hospital-alt"></i> fas fa-hospital-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hospital-symbol"></i> fas fa-hospital-symbol 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hot-tub"></i> fas fa-hot-tub 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hotdog"></i> fas fa-hotdog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hotel"></i> fas fa-hotel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hotjar"></i> fab fa-hotjar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hourglass"></i> fas fa-hourglass 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hourglass"></i> fas fa-hourglass 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hourglass-end"></i> fas fa-hourglass-end 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hourglass-half"></i> fas fa-hourglass-half 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hourglass-start"></i> fas fa-hourglass-start 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-house-damage"></i> fas fa-house-damage 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-houzz"></i> fab fa-houzz 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-hryvnia"></i> fas fa-hryvnia 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-html5"></i> fab fa-html5 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-hubspot"></i> fab fa-hubspot 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-i-cursor"></i> fas fa-i-cursor 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ice-cream"></i> fas fa-ice-cream 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-icicles"></i> fas fa-icicles 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-id-badge"></i> fas fa-id-badge 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-id-badge"></i> fas fa-id-badge 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-id-card"></i> fas fa-id-card 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-id-card"></i> fas fa-id-card 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-id-card-alt"></i> fas fa-id-card-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-igloo"></i> fas fa-igloo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-image"></i> fas fa-image 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-image"></i> far fa-image 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-images"></i> fas fa-images 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-images"></i> far fa-images 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-imdb"></i> fab fa-imdb 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-inbox"></i> fas fa-inbox 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-indent"></i> fas fa-indent 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-industry"></i> fas fa-industry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-infinity"></i> fas fa-infinity 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-info"></i> fas fa-info 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-info-circle"></i> fas fa-info-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-instagram"></i> fab fa-instagram 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-intercom"></i> fab fa-intercom 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-internet-explorer"></i> fab fa-internet-explorer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-invision"></i> fab fa-invision 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ioxhost"></i> fab fa-ioxhost 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-italic"></i> fas fa-italic 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-itunes"></i> fab fa-itunes 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-itunes-note"></i> fab fa-itunes-note 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-java"></i> fab fa-java 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-jedi"></i> fas fa-jedi 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-jedi-order"></i> fab fa-jedi-order 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-jenkins"></i> fab fa-jenkins 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-jira"></i> fab fa-jira 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-joget"></i> fab fa-joget 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-joint"></i> fas fa-joint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-joomla"></i> fab fa-joomla 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-journal-whills"></i> fas fa-journal-whills 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-js"></i> fab fa-js 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-js-square"></i> fab fa-js-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-jsfiddle"></i> fab fa-jsfiddle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-kaaba"></i> fas fa-kaaba 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-kaaba"></i> fas fa-kaaba 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-key"></i> fas fa-key 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-keybase"></i> fab fa-keybase
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-keyboard"></i> fas fa-keyboard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-keyboard"></i> far fa-keyboard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-keycdn"></i> fab fa-keycdn 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-khanda"></i> fas fa-khanda 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-kickstarter"></i> fab fa-kickstarter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-kickstarter-k"></i> fab fa-kickstarter-k 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-kiss"></i> fas fa-kiss 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-kiss"></i> far fa-kiss 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-kiss-beam"></i> fas fa-kiss-beam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-kiss-beam"></i> far fa-kiss-beam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-kiss-wink-heart"></i> fas fa-kiss-wink-heart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-kiss-wink-heart"></i> far fa-kiss-wink-heart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-kiwi-bird"></i> fas fa-kiwi-bird 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-korvue"></i> fab fa-korvue 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-landmark"></i> fas fa-landmark 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-language"></i> fas fa-language 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-laptop"></i> fas fa-laptop 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-laptop-code"></i> fas fa-laptop-code 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-laptop-medical"></i> fas fa-laptop-medical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-laravel"></i> fab fa-laravel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-lastfm"></i> fab fa-lastfm 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-lastfm-square"></i> fab fa-lastfm-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-laugh"></i> fas fa-laugh 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-laugh"></i> far fa-laugh 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-laugh-beam"></i> fas fa-laugh-beam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-laugh-beam"></i> far fa-laugh-beam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-laugh-squint"></i> fas fa-laugh-squint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-laugh-squint"></i> far fa-laugh-squint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-laugh-wink"></i> fas fa-laugh-wink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-laugh-wink"></i> far fa-laugh-wink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-layer-group"></i> fas fa-layer-group 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-leaf"></i> fas fa-leaf 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-leanpub"></i> fab fa-leanpub 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-lemon"></i> fas fa-lemon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-lemon"></i> far fa-lemon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-less"></i> fab fa-less 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-less-than"></i> fas fa-less-than 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-less-than-equal"></i> fas fa-less-than-equal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-level-down-alt"></i> fas fa-level-down-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-level-up-alt"></i> fas fa-level-up-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-life-ring"></i> fas fa-life-ring 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-life-ring"></i> fas fa-life-ring 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-lightbulb"></i> fas fa-lightbulb 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-lightbulb"></i> far fa-lightbulb 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-line"></i> fab fa-line 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-link"></i> fas fa-link 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-linkedin"></i> fab fa-linkedin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-linkedin-in"></i> fab fa-linkedin-in 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-linode"></i> fab fa-linode 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-linux"></i> fab fa-linux 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-lira-sign"></i> fas fa-lira-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-list"></i> fas fa-list 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-list-alt"></i> fas fa-list-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-list-alt"></i> fas fa-list-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-list-ol"></i> fas fa-list-ol 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-list-ul"></i> fas fa-list-ul 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-location-arrow"></i> fas fa-location-arrow 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-lock"></i> fas fa-lock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-lock-open"></i> fas fa-lock-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-long-arrow-alt-down"></i> fas fa-long-arrow-alt-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-long-arrow-alt-left"></i> fas fa-long-arrow-alt-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-long-arrow-alt-right"></i> fas fa-long-arrow-alt-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-long-arrow-alt-up"></i> fas fa-long-arrow-alt-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-low-vision"></i> fas fa-low-vision 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-luggage-cart"></i> fas fa-luggage-cart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-lyft"></i> fab fa-lyft 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-magento"></i> fab fa-magento 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-magic"></i> fas fa-magic 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-magnet"></i> fas fa-magnet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mail-bulk"></i> fas fa-mail-bulk 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-mailchimp"></i> fab fa-mailchimp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-male"></i> fas fa-male 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-mandalorian"></i> fab fa-mandalorian 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-map"></i> fas fa-map 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-map"></i> far fa-map 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-map-marked"></i> fas fa-map-marked 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-map-marked-alt"></i> fas fa-map-marked-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-map-marker"></i> fas fa-map-marker 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-map-marker-alt"></i> fas fa-map-marker-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-map-pin"></i> fas fa-map-pin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-map-signs"></i> fas fa-map-signs 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-markdown"></i> fab fa-markdown 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-marker"></i> fas fa-marker 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mars"></i> fas fa-mars 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mars-double"></i> fas fa-mars-double 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mars-stroke"></i> fas fa-mars-stroke 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mars-stroke-h"></i> fas fa-mars-stroke-h 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mars-stroke-v"></i> fas fa-mars-stroke-v 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mask"></i> fas fa-mask 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-mastodon"></i> fab fa-mastodon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-maxcdn"></i> fab fa-maxcdn 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-medal"></i> fas fa-medal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-medapps"></i> fab fa-medapps 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-medium"></i> fab fa-medium 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-medium-m"></i> fab fa-medium-m 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-medkit"></i> fas fa-medkit 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-medrt"></i> fab fa-medrt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-meetup"></i> fab fa-meetup 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-megaport"></i> fab fa-megaport 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-meh"></i> fas fa-meh 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-meh"></i> fas fa- meh
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-meh-blank"></i> fas fa-meh-blank 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-meh-blank"></i> fas fa-meh-blank 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-meh-rolling-eyes"></i> fas fa-meh-rolling-eyes 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-meh-rolling-eyes"></i> fas fa-meh-rolling-eyes 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-memory"></i> fas fa-memory 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-mendeley"></i> fab fa-mendeley 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-menorah"></i> fas fa-menorah 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mercury"></i> fas fa-mercury 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-meteor"></i> fas fa-meteor 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-microchip"></i> fas fa-microchip 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-microphone"></i> fas fa-microphone 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-microphone-alt"></i> fas fa-microphone-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-microphone-alt-slash"></i> fas fa-microphone-alt-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-microphone-slash"></i> fas fa-microphone-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-microscope"></i> fas fa-microscope 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-microsoft"></i> fab fa-microsoft 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-minus"></i> fas fa-minus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-minus-circle"></i> fas fa-minus-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-minus-circle"></i> fas fa-minus-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-minus-square"></i> fas fa-minus-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-minus-square"></i> fas fa-minus-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-mix"></i> fab fa-mix 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-mixcloud"></i> fab fa-mixcloud 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-mizuni"></i> fab fa-mizuni 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mobile"></i> fas fa-mobile 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mobile-alt"></i> fas fa-mobile-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-modx"></i> fab fa-modx 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-monero"></i> fab fa-monero 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-money-bill"></i> fas fa-money-bill 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-money-bill-alt"></i> fas fa-money-bill-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-money-bill-alt"></i> far fa-money-bill-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-money-bill-wave"></i> fas fa-money-bill-wave 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-money-bill-wave-alt"></i> fas fa-money-bill-wave-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-money-check"></i> fas fa-money-check 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-money-check-alt"></i> fas fa-money-check-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-monument"></i> fas fa-monument 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-moon"></i> fas fa-moon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-moon"></i> far fa-moon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mortar-pestle"></i> fas fa-mortar-pestle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mosque"></i> fas fa-mosque 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-motorcycle"></i> fas fa-motorcycle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mountain"></i> fas fa-mountain 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mouse-pointer"></i> fas fa-mouse-pointer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-mug-hot"></i> fas fa-mug-hot 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-music"></i> fas fa-music 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-napster"></i> fab fa-napster 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-neos"></i> fab fa-neos 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-network-wired"></i> fas fa-network-wired 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-neuter"></i> fas fa-neuter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-newspaper"></i> fas fa-newspaper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-newspaper"></i> far fa-newspaper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-nimblr"></i> fab fa-nimblr 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-nintendo-switch"></i> fab fa-nintendo-switch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-node"></i> fab fa-node 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-node-js"></i> fab fa-node-js 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-not-equal"></i> fas fa-not-equal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-notes-medical"></i> fas fa-notes-medical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-npm"></i> fab fa-npm 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ns8"></i> fab fa-ns8 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-nutritionix"></i> fab fa-nutritionix 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-object-group"></i> fas fa-object-group 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-object-group"></i> fas fa-object-group 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-object-ungroup"></i> fas fa-object-ungroup 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-object-ungroup"></i> fas fa-object-ungroup 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-odnoklassniki"></i> fab fa-odnoklassniki 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-odnoklassniki-square"></i> fab fa-odnoklassniki-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-oil-can"></i> fas fa-oil-can 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-old-republic"></i> fab fa-old-republic 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-om"></i> fas fa-om 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-opencart"></i> fab fa-opencart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-openid"></i> fab fa-openid 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-opera"></i> fab fa-opera 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-optin-monster"></i> fab fa-optin-monster 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-osi"></i> fab fa-osi 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-otter"></i> fas fa-otter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-outdent"></i> fas fa-outdent 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-page4"></i> fab fa-page4 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pagelines"></i> fab fa-pagelines 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pager"></i> fas fa-pager 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-paint-brush"></i> fas fa-paint-brush 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-paint-roller"></i> fas fa-paint-roller 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-palette"></i> fas fa-palette 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-palfed"></i> fab fa-palfed 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pallet"></i> fas fa-pallet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-paper-plane"></i> fas fa-paper-plane 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-paper-plane"></i> far fa-paper-plane 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-paperclip"></i> fas fa-paperclip 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-parachute-box"></i> fas fa-parachute-box 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-paragraph"></i> fas fa-paragraph 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-parking"></i> fas fa-parking 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-passport"></i> fas fa-passport 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pastafarianism"></i> fas fa-pastafarianism 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-paste"></i> fas fa-paste 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-patreon"></i> fab fa-patreon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pause"></i> fas fa-pause 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pause-circle"></i> fas fa-pause-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pause-circle"></i> fas fa-pause-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-paw"></i> fas fa-paw 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-paypal"></i> fab fa-paypal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-peace"></i> fas fa-peace 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pagelines"></i> fab fa-pagelines 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pen-alt"></i> fas fa-pen-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pen-fancy"></i> fas fa-pen-fancy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pen-nib"></i> fas fa-pen-nib 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pen-square"></i> fas fa-pen-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pencil-alt"></i> fas fa-pencil-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pencil-ruler"></i> fas fa-pencil-ruler 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-penny-arcade"></i> fab fa-penny-arcade 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-people-carry"></i> fas fa-people-carry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pepper-hot"></i> fas fa-pepper-hot 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-percent"></i> fas fa-percent 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-percentage"></i> fas fa-percentage 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-periscope"></i> fab fa-periscope 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-person-booth"></i> fas fa-person-booth 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-phabricator"></i> fab fa-phabricator 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-phoenix-framework"></i> fab fa-phoenix-framework 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-phoenix-squadron"></i> fab fa-phoenix-squadron 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-phone"></i> fas fa-phone 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-phone-slash"></i> fas fa-phone-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-phone-square"></i> fas fa-phone-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-phone-volume"></i> fas fa-phone-volume 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-php"></i> fab fa-php 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pied-piper"></i> fab fa-pied-piper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pied-piper-alt"></i> fab fa-pied-piper-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pied-piper-hat"></i> fab fa-pied-piper-hat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pied-piper-pp"></i> fab fa-pied-piper-pp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-piggy-bank"></i> fas fa-piggy-bank 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pills"></i> fas fa-pills 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pinterest"></i> fab fa-pinterest 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pinterest-p"></i> fab fa-pinterest-p 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pinterest-square"></i> fab fa-pinterest-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pizza-slice"></i> fas fa-pizza-slice 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-place-of-worship"></i> fas fa-place-of-worship 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-plane"></i> fas fa-plane 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-plane-arrival"></i> fas fa-plane-arrival 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-plane-departure"></i> fas fa-plane-departure 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-play"></i> fas fa-play 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-play-circle"></i> fas fa-play-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-play-circle"></i> fas fa-play-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-playstation"></i> fab fa-playstation 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-plug"></i> fas fa-plug 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-plus"></i> fas fa-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-plus-circle"></i> fas fa-plus-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-plus-square"></i> fas fa-plus-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-plus-square"></i> far fa-plus-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-podcast"></i> fas fa-podcast 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-poll"></i> fas fa-poll 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-poll-h"></i> fas fa-poll-h 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-poo"></i> fas fa-poo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-poo-storm"></i> fas fa-poo-storm 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-poop"></i> fas fa-poop 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-portrait"></i> fas fa-portrait 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pound-sign"></i> fas fa-pound-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-power-off"></i> fas fa-power-off 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-pray"></i> fas fa-pray 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-praying-hands"></i> fas fa-praying-hands 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-prescription"></i> fas fa-prescription 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-prescription-bottle"></i> fas fa-prescription-bottle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-prescription-bottle-alt"></i> fas fa-prescription-bottle-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-print"></i> fas fa-print 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-procedures"></i> fas fa-procedures 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-product-hunt"></i> fab fa-product-hunt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-project-diagram"></i> fas fa-project-diagram 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-pushed"></i> fab fa-pushed 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-puzzle-piece"></i> fas fa-puzzle-piece 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-python"></i> fab fa-python 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-qq"></i> fab fa-qq 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-qrcode"></i> fas fa-qrcode 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-question"></i> fas fa-question 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-question"></i> fas fa-question 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-question-circle"></i> fas fa-question-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-quidditch"></i> fas fa-quidditch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-quinscape"></i> fab fa-quinscape 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-quora"></i> fab fa-quora 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-quote-left"></i> fas fa-quote-left 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-quote-right"></i> fas fa-quote-right 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-quran"></i> fas fa-quran 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-r-project"></i> fab fa-r-project 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-radiation"></i> fas fa-radiation 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-radiation-alt"></i> fas fa-radiation-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-rainbow"></i> fas fa-rainbow 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-random"></i> fas fa-random 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-raspberry-pi"></i> fab fa-raspberry-pi 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ravelry"></i> fab fa-ravelry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-react"></i> fab fa-react 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-reacteurope"></i> fab fa-reacteurope 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-readme"></i> fab fa-readme 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-rebel"></i> fab fa-rebel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-receipt"></i> fas fa-receipt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-recycle"></i> fas fa-recycle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-red-river"></i> fab fa-red-river 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-reddit"></i> fab fa-reddit 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-reddit-alien"></i> fab fa-reddit-alien 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-reddit-square"></i> fab fa-reddit-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-redhat"></i> fab fa-redhat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-redo"></i> fas fa-redo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-redo-alt"></i> fas fa-redo-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-registered"></i> fas fa-registered 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-registered"></i> far fa-registered 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-renren"></i> fab fa-renren 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-reply"></i> fas fa-reply 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-reply-all"></i> fas fa-reply-all 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-replyd"></i> fab fa-replyd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-republican"></i> fas fa-republican 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-researchgate"></i> fab fa-researchgate 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-resolving"></i> fab fa-resolving 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-restroom"></i> fas fa-restroom 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-retweet"></i> fas fa-retweet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-rev"></i> fab fa-rev 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ribbon"></i> fas fa-ribbon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ring"></i> fas fa-ring 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-road"></i> fas fa-road 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-robot"></i> fas fa-robot 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-rocket"></i> fas fa-rocket 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-rocketchat"></i> fab fa-rocketchat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-rockrms"></i> fab fa-rockrms 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-route"></i> fas fa-route 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-rss"></i> fas fa-rss 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-rss-square"></i> fas fa-rss-square     
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ruble-sign"></i> fas fa-ruble-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ruler"></i> fas fa-ruler 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ruler-combined"></i> fas fa-ruler-combined 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ruler-horizontal"></i> fas fa-ruler-horizontal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ruler-vertical"></i> fas fa-ruler-vertical 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-running"></i> fas fa-running 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-rupee-sign"></i> fas fa-rupee-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sad-cry"></i> fas fa-sad-cry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-sad-cry"></i> far fa-sad-cry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sad-tear"></i> fas fa-sad-tear 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-sad-tear"></i> far fa-sad-tear 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-safari"></i> fab fa-safari 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-sass"></i> fab fa-sass 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-satellite"></i> fas fa-satellite 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-satellite-dish"></i> fas fa-satellite-dish 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-save"></i> fas fa-save 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-save"></i> far fa-save 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-schlix"></i> fab fa-schlix 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-school"></i> fas fa-school 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-screwdriver"></i> fas fa-screwdriver 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-scribd"></i> fab fa-scribd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-scroll"></i> fas fa-scroll 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sd-card"></i> fas fa-sd-card 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-search"></i> fas fa-search 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-search-dollar"></i> fas fa-search-dollar 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-search-location"></i> fas fa-search-location 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-search-minus"></i> fas fa-search-minus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-search-plus"></i> fas fa-search-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-searchengin"></i> fab fa-searchengin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-seedling"></i> fas fa-seedling 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-sellcast"></i> fab fa-sellcast 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-sellsy"></i> fab fa-sellsy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-server"></i> fas fa-server 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-shirtsinbulk"></i> fab fa-shirtsinbulk 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shapes"></i> fas fa-shapes 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-share"></i> fas fa-share 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-share-alt"></i> fas fa-share-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-share-alt-square"></i> fas fa-share-alt-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-share-square"></i> fas fa-share-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-share-square"></i> fas fa-share-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shekel-sign"></i> fas fa-shekel-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shield-alt"></i> fas fa-shield-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ship"></i> fas fa-ship 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shipping-fast"></i> fas fa-shipping-fast 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-servicestack"></i> fab fa-servicestack 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shoe-prints"></i> fas fa-shoe-prints 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shopping-bag"></i> fas fa-shopping-bag 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shopping-basket"></i> fas fa-shopping-basket 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shopping-cart"></i> fas fa-shopping-cart 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-shopware"></i> fab fa-shopware 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shower"></i> fas fa-shower 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-shuttle-van"></i> fas fa-shuttle-van 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sign"></i> fas fa-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sign-in-alt"></i> fas fa-sign-in-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sign-language"></i> fas fa-sign-language 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sign-out-alt"></i> fas fa-sign-out-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-signal"></i> fas fa-signal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-signature"></i> fas fa-signature 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sim-card"></i> fas fa-sim-card 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-simplybuilt"></i> fab fa-simplybuilt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-sistrix"></i> fab fa-sistrix 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sitemap"></i> fas fa-sitemap 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-sith"></i> fab fa-sith 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-skating"></i> fas fa-skating 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-sketch"></i> fab fa-sketch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-skiing"></i> fas fa-skiing 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-skiing-nordic"></i> fas fa-skiing-nordic 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-skull"></i> fas fa-skull 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-skull-crossbones"></i> fas fa-skull-crossbones 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-skyatlas"></i> fab fa-skyatlas 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-skype"></i> fab fa-skype 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-slack"></i> fab fa-slack 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-slack-hash"></i> fab fa-slack-hash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-slash"></i> fas fa-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sleigh"></i> fas fa-sleigh 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sliders-h"></i> fas fa-sliders-h 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-slideshare"></i> fab fa-slideshare 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-smile"></i> fas fa-smile 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-smile"></i> far fa-smile 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-smile-beam"></i> fas fa-smile-beam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-smile-beam"></i> far fa-smile-beam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-smile-wink"></i> fas fa-smile-wink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-smile-wink"></i> far fa-smile-wink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-smog"></i> fas fa-smog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-smoking"></i> fas fa-smoking 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-smoking-ban"></i> fas fa-smoking-ban 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sms"></i> fas fa-sms 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-snapchat"></i> fab fa-snapchat 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-snapchat-ghost"></i> fab fa-snapchat-ghost 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-snapchat-square"></i> fab fa-snapchat-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-snowboarding"></i> fas fa-snowboarding 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-snowflake"></i> fas fa-snowflake 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-snowflake"></i> far fa-snowflake 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-snowman"></i> fas fa-snowman 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-snowplow"></i> fas fa-snowplow 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-socks"></i> fas fa-socks 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-solar-panel"></i> fas fa-solar-panel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort"></i> fas fa-sort 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort-alpha-down"></i> fas fa-sort-alpha-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort-alpha-up"></i> fas fa-sort-alpha-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort-amount-down"></i> fas fa-sort-amount-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort-amount-up"></i> fas fa-sort-amount-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort-down"></i> fas fa-sort-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort-numeric-down"></i> fas fa-sort-numeric-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort-numeric-up"></i> fas fa-sort-numeric-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sort-up"></i> fas fa-sort-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-soundcloud"></i> fab fa-soundcloud 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-sourcetree"></i> fab fa-sourcetree 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-spa"></i> fas fa-spa 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-space-shuttle"></i> fas fa-space-shuttle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-speakap"></i> fab fa-speakap 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-spider"></i> fas fa-spider 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-spinner"></i> fas fa-spinner 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-splotch"></i> fas fa-splotch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-spotify"></i> fab fa-spotify 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-spray-can"></i> fas fa-spray-can 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-square"></i> fas fa-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-square"></i> far fa-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-square-full    "></i> fas fa-square-full    
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-square-root-alt"></i> fas fa-square-root-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-squarespace"></i> fab fa-squarespace 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-stack-exchange"></i> fab fa-stack-exchange 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-stack-overflow"></i> fab fa-stack-overflow 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-stamp"></i> fas fa-stamp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-star"></i> fas fa-star 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-star"></i> far fa-star 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-star-and-crescent"></i> fas fa-star-and-crescent 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-star-half"></i> fas fa-star-half 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-star-half"></i> far fa-star-half 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-star-half-alt"></i> fas fa-star-half-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-star-of-david"></i> fas fa-star-of-davids 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-star-of-life"></i> fas fa-star-of-life 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-staylinked"></i> fab fa-staylinked 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-steam"></i> fab fa-steam 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-steam-square"></i> fab fa-steam-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-steam-symbol"></i> fab fa-steam-symbol 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-step-backward"></i> fas fa-step-backward 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-step-forward"></i> fas fa-step-forward 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-stethoscope"></i> fas fa-stethoscope 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-sticker-mule"></i> fab fa-sticker-mule 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sticky-note"></i> fas fa-sticky-note 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-sticky-note"></i> far fa-sticky-note 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-stop"></i> fas fa-stop 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-stop-circle"></i> fas fa-stop-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-stop-circle"></i> far fa-stop-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-stopwatch"></i> fas fa-stopwatch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-store"></i> fas fa-store 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-store-alt"></i> fas fa-store-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-strava"></i> fab fa-strava 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-stream"></i> fas fa-stream 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-street-view"></i> fas fa-street-view 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-strikethrough"></i> fas fa-strikethrough 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-stripe"></i> fab fa-stripe 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-stripe-s"></i> fab fa-stripe-s 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-stroopwafel"></i> fas fa-stroopwafel 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-studiovinari"></i> fab fa-studiovinari 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-stumbleupon"></i> fab fa-stumbleupon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-stumbleupon-circle"></i> fab fa-stumbleupon-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-subscript"></i> fas fa-subscript 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-subway"></i> fas fa-subway 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-suitcase"></i> fas fa-suitcase 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-suitcase-rolling"></i> fas fa-suitcase-rolling 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sun"></i> fas fa-sun 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-sun"></i> far fa-sun 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-superpowers"></i> fab fa-superpowers 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-superscript"></i> fas fa-superscript 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-supple"></i> fab fa-supple 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-surprise"></i> fas fa-surprise 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-surprise"></i> far fa-surprise 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-suse"></i> fab fa-suse 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-swatchbook"></i> fas fa-swatchbook 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-swimmer"></i> fas fa-swimmer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-swimming-pool"></i> fas fa-swimming-pool 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-synagogue"></i> fas fa-synagogue 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sync"></i> fas fa-sync 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-sync-alt"></i> fas fa-sync-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-syringe"></i> fas fa-syringe 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-table"></i> fas fa-table 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-table-tennis"></i> fas fa-table-tennis 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tablet"></i> fas fa-tablet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tablet-alt"></i> fas fa-tablet-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tablets"></i> fas fa-tablets 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tachometer-alt"></i> fas fa-tachometer-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tag"></i> fas fa-tag 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tags"></i> fas fa-tags 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tape"></i> fas fa-tape 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tasks"></i> fas fa-tasks 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-taxi"></i> fas fa-taxi 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-teamspeak"></i> fab fa-teamspeak 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-teeth"></i> fas fa-teeth 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-teeth-open"></i> fas fa-teeth-open 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-telegram"></i> fab fa-telegram 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-telegram-plane"></i> fab fa-telegram-plane 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-temperature-high"></i> fas fa-temperature-high 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-temperature-low"></i> fas fa-temperature-low 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-tencent-weibo"></i> fab fa-tencent-weibo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tenge"></i> fas fa-tenge 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-terminal"></i> fas fa-terminal 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-text-height"></i> fas fa-text-height 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-text-width"></i> fas fa-text-width 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-th"></i> fas fa-th 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-th-large"></i> fas fa-th-large 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-th-list"></i> fas fa-th-list 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-the-red-yeti"></i> fab fa-the-red-yeti 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-theater-masks"></i> fas fa-theater-masks 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-themeco"></i> fab fa-themeco 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-themeisle"></i> fab fa-themeisle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thermometer"></i> fas fa-thermometer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thermometer-empty"></i> fas fa-thermometer-empty 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thermometer-full"></i> fas fa-thermometer-full 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thermometer-half"></i> fas fa-thermometer-half 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thermometer-quarter"></i> fas fa-thermometer-quarter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thermometer-three-quarters"></i> fas fa-thermometer-three-quarters 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-think-peaks"></i> fab fa-think-peaks 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thumbs-down"></i> fas fa-thumbs-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-thumbs-down"></i> far fa-thumbs-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thumbs-up"></i> fas fa-thumbs-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-thumbs-up"></i> far fa-thumbs-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-thumbtack"></i> fas fa-thumbtack 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-ticket-alt"></i> fas fa-ticket-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-times"></i> fas fa-times 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-times-circle"></i> fas fa-times-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-times-circle"></i> fas fa-times-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tint"></i> fas fa-tint 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tint-slash"></i> fas fa-tint-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tired"></i> fas fa-tired 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-tired"></i> far fa-tired 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-toggle-off"></i> fas fa-toggle-off 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-toggle-on"></i> fas fa-toggle-on 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-toilet"></i> fas fa-toilet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-toilet-paper"></i> fas fa-toilet-paper 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-toolbox"></i> fas fa-toolbox 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tools"></i> fas fa-tools 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tooth"></i> fas fa-tooth 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-torah"></i> fas fa-torah 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-torii-gate"></i> fas fa-torii-gate 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tractor"></i> fas fa-tractor 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-trade-federation"></i> fab fa-trade-federation 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-trademark"></i> fas fa-trademark 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-traffic-light"></i> fas fa-traffic-light 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-train"></i> fas fa-train 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tram"></i> fas fa-tram 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-transgender"></i> fas fa-transgender 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-transgender-alt"></i> fas fa-transgender-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-trash"></i> fas fa-trash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-trash-alt"></i> fas fa-trash-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-trash-alt"></i> far fa-trash-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-trash-restore"></i> fas fa-trash-restore 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-trash-restore-alt"></i> fas fa-trash-restore-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tree"></i> fas fa-tree 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-trello"></i> fab fa-trello 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-tripadvisor"></i> fab fa-tripadvisor 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-trophy"></i> fas fa-trophy 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-truck"></i> fas fa-truck 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-truck-loading"></i> fas fa-truck-loading 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-truck-monster"></i> fas fa-truck-monster 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-truck-moving"></i> fas fa-truck-moving 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-truck-pickup"></i> fas fa-truck-pickup 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tshirt"></i> fas fa-tshirt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tty"></i> fas fa-tty 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-tumblr"></i> fab fa-tumblr 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-tumblr-square"></i> fab fa-tumblr-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-tv"></i> fas fa-tv 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-twitch"></i> fab fa-twitch 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-twitter"></i> fab fa-twitter 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-twitter-square"></i> fab fa-twitter-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-typo3"></i> fab fa-typo3 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-uber"></i> fab fa-uber 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ubuntu"></i> fab fa-ubuntu 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-uikit"></i> fab fa-uikit 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-umbrella"></i> fas fa-umbrella 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-umbrella-beach"></i> fas fa-umbrella-beach 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-underline"></i> fas fa-underline 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-undo"></i> fas fa-undo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-undo-alt"></i> fas fa-undo-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-uniregistry"></i> fab fa-uniregistry 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-universal-access"></i> fas fa-universal-access 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-university"></i> fas fa-university 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-unlink"></i> fas fa-unlink 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-unlock"></i> fas fa-unlock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-unlock-alt"></i> fas fa-unlock-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-untappd"></i> fab fa-untappd 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-upload"></i> fas fa-upload 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ups"></i> fab fa-ups 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-usb"></i> fab fa-usb 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user"></i> fas fa-user 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-user"></i> far fa-user 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-alt"></i> fas fa-user-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-alt-slash"></i> fas fa-user-alt-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-astronaut"></i> fas fa-user-astronaut 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-check"></i> fas fa-user-check 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-circle"></i> fas fa-user-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-circle"></i> fas fa-user-circle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-clock"></i> fas fa-user-clock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-cog"></i> fas fa-user-cog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-edit"></i> fas fa-user-edit 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-friends"></i> fas fa-user-friends 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-graduate"></i> fas fa-user-graduate 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-injured"></i> fas fa-user-injured 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-lock"></i> fas fa-user-lock 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-md"></i> fas fa-user-md 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-minus"></i> fas fa-user-minus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-ninja"></i> fas fa-user-ninja 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-nurse"></i> fas fa-user-nurse 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-plus"></i> fas fa-user-plus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-secret"></i> fas fa-user-secret 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-shield"></i> fas fa-user-shield 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-slash"></i> fas fa-user-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-tag"></i> fas fa-user-tag 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-tie"></i> fas fa-user-tie 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-user-times"></i> fas fa-user-times 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-users"></i> fas fa-users 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-users-cog"></i> fas fa-users-cog 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-usps"></i> fab fa-usps 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-ussunnah"></i> fab fa-ussunnah 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-utensil-spoon"></i> fas fa-utensil-spoon 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-utensils"></i> fas fa-utensils 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-vaadin"></i> fab fa-vaadin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-vector-square"></i> fas fa-vector-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-venus"></i> fas fa-venus 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-venus-double"></i> fas fa-venus-double 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-venus-mars"></i> fas fa-venus-mars 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-viacoin"></i> fab fa-viacoin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-viadeo"></i> fab fa-viadeo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-viadeo-square"></i> fab fa-viadeo-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-vial"></i> fas fa-vial 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-vials"></i> fas fa-vials 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-viber"></i> fab fa-viber 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-video"></i> fas fa-video 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-video-slash"></i> fas fa-video-slash 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-vihara"></i> fas fa-vihara 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-vimeo"></i> fab fa-vimeo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-vimeo-square"></i> fab fa-vimeo-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-vimeo-v"></i> fab fa-vimeo-v 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-vine"></i> fab fa-vine 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-vk"></i> fab fa-vk 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-vnv"></i> fab fa-vnv 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-volleyball-ball"></i> fas fa-volleyball-ball 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-volume-down"></i> fas fa-volume-down 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-volume-mute"></i> fas fa-volume-mute 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-volume-off"></i> fas fa-volume-off 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-volume-up"></i> fas fa-volume-up 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-vote-yea"></i> fas fa-vote-yea 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-vr-cardboard"></i> fas fa-vr-cardboard 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-vuejs"></i> fab fa-vuejs 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-walking"></i> fas fa-walking 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-wallet"></i> fas fa-wallet 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-warehouse"></i> fas fa-warehouse 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-water"></i> fas fa-water 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-weebly"></i> fab fa-weebly 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-weibo"></i> fab fa-weibo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-weight"></i> fas fa-weight 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-weight-hanging"></i> fas fa-weight-hanging 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-weixin"></i> fab fa-weixin 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-whatsapp"></i> fab fa-whatsapp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-whatsapp-square"></i> fab fa-whatsapp-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-wheelchair"></i> fas fa-wheelchair 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-whmcs"></i> fab fa-whmcs 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-wifi"></i> fas fa-wifi 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wikipedia-w"></i> fab fa-wikipedia-w 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-wind"></i> fas fa-wind
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-window-close"></i> fas fa-window-close 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-window-close"></i> far fa-window-close 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-window-maximize"></i> fas fa-window-maximize 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-window-maximize"></i> far fa-window-maximize 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-window-minimize"></i> fas fa-window-minimize 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-window-minimize"></i> fas fa-window-minimize 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-window-restore"></i> fas fa-window-restore 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="far  h5 mr-2 fa-window-restore"></i> far fa-window-restore 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-windows"></i> fab fa-windows 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-wine-bottle"></i> fas fa-wine-bottle 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-wine-glass"></i> fas fa-wine-glass 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-wine-glass-alt"></i> fas fa-wine-glass-alt 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wix"></i> fab fa-wix 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wizards-of-the-coast"></i> fab fa-wizards-of-the-coast 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wolf-pack-battalion"></i> fab fa-wolf-pack-battalion 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-won-sign"></i> fas fa-won-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wordpress"></i> fab fa-wordpress 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wordpress-simple"></i> fab fa-wordpress-simple 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wpbeginner"></i> fab fa-wpbeginner 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wpexplorer"></i> fab fa-wpexplorer 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wpforms"></i> fab fa-wpforms 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-wpressr"></i> fab fa-wpressr 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-wrench"></i> fas fa-wrench 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-x-ray"></i> fas fa-x-ray 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-xbox"></i> fab fa-xbox 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-xing"></i> fab fa-xing 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-xing-square"></i> fab fa-xing-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-y-combinator"></i> fab fa-y-combinator 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-yahoo"></i> fab fa-yahoo 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-yandex"></i> fab fa-yandex 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-yandex-international"></i> fab fa-yandex-international 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-yarn"></i> fab fa-yarn 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-yelp"></i> fab fa-yelp 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-yen-sign"></i> fas fa-yen-sign 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fas  h5 mr-2 fa-yin-yang"></i> fas fa-yin-yang 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-yoast"></i> fab fa-yoast 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-youtube"></i> fab fa-youtube 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-youtube-square"></i> fab fa-youtube-square 
                                </div>
                                <div class="font-icon-list p-2 border all mx-1 mb-2">
                                    <i class="fab  h5 mr-2 fa-zhihu"></i> fab fa-zhihu 
                                </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>
